<template>
  <section class="o-section o-container-">
    <Channels />
    <TrackList />
    <footer v-if="showLoadMore" class="o-section__footer u-center">
        <a href="#" @click.prevent="$store.dispatch('playlist/fetchNext')" class="o-section__button [ c-button c-button--large ]">Toon meer</a>
    </footer>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import TrackList from './TrackList';
import Channels from './Channels';
export default {
  name: 'Playlist',
  components: { TrackList, Channels },
  computed: {
    ...mapState({
      showLoadMore: state => state.playlist.isLoading === false
    }),
  },
  props: ['stationSlug'],
  async created() {
    this.$store.dispatch('playlist/fetchSlugOrDefault', this.stationSlug)
  }
};
</script>
